import { useEffect, useState } from 'react'
import {
	RiArrowLeftSLine,
	RiArrowRightSLine,
	RiCloseLine
} from 'react-icons/ri'

import { classNames } from 'utils'
import { GTooltip } from '../g-tooltip'
import { GNoticeProps, GNoticeType } from './types'

const buildClassName = (type = 'warning') => {
	const commonStyles =
		'app-notice-banner flex justify-between border border-t-dark-blue bg-t-step-inactive py-5 items-center text-md font-bold'
	let typeStyles = ''

	if (type === 'warning') typeStyles = 'bg-amber-100 text-amber-700 rounded-3xl px-6'
	if (type === 'critical') typeStyles = 'bg-red-100 text-red-700 rounded-3xl px-6'
	if (type === 'positive') typeStyles = 'bg-green-100 text-green-700 rounded-3xl px-6'
	if (type === 'brand')
		typeStyles = 'bg-brand-50 border-brand text-t-base-blue rounded-2xl px-5'

	return classNames(commonStyles, typeStyles)
}

export const GNotice = ({ notices, ...props }: GNoticeProps) => {
	const [currentNoticeIndex, setCurrentNoticeIndex] = useState(0)
	const [currentNotices, setCurrentNotices] = useState<GNoticeType[]>([])

	useEffect(() => {
		setCurrentNotices(notices)
	}, [notices])

	const currentNotice = currentNotices[currentNoticeIndex]
	const showSwitchingComponent = currentNotices.length > 1
	const disablePrevious = currentNoticeIndex === 0
	const disableNext = currentNoticeIndex === currentNotices.length - 1

	const switchPreviousNotice = () => {
		setCurrentNoticeIndex((prev) => prev - 1)
	}
	const switchNextNotice = () => {
		setCurrentNoticeIndex((prev) => prev + 1)
	}
	const dismiss = () => {
		setCurrentNotices((prev) => [
			...prev.filter((notice) => notice.key !== currentNotice.key)
		])
		if (currentNoticeIndex !== 0) {
			setCurrentNoticeIndex((prev) => prev - 1)
		}

		if (currentNotice.onDismiss) currentNotice.onDismiss()
	}

	if (!currentNotice) return null

	return (
		<div className="max-w-full mx-auto px-4 pt-6">
			<div
				className={classNames(
					buildClassName(currentNotice.type),
					currentNotice.containerClassName || ''
				)}
				{...props}
			>
				<div className="flex items-center w-full">
					{showSwitchingComponent && (
						<div className="flex items-center mr-2" data-testid="switching">
							<button
								type="button"
								onClick={switchPreviousNotice}
								data-testid="switch-previous"
								disabled={disablePrevious}
							>
								<RiArrowLeftSLine
									className={classNames(
										'w-5 h-6',
										disablePrevious ? 'text-gray-500' : ''
									)}
								/>
							</button>
							{currentNoticeIndex + 1} / {currentNotices.length}
							<button
								type="button"
								onClick={switchNextNotice}
								data-testid="switch-next"
								disabled={disableNext}
							>
								<RiArrowRightSLine
									className={classNames(
										'w-5 h-6',
										disableNext ? 'text-gray-500' : ''
									)}
								/>
							</button>
						</div>
					)}
					{currentNotice.notice}
				</div>
				{currentNotice.hideDismiss ? (
					<></>
				) : (
					<GTooltip
						content="Dismiss"
						data-testid="dismiss-button"
						onClick={dismiss}
					>
						<RiCloseLine className="w-5 h-6 text-t-close-toast" />
					</GTooltip>
				)}
			</div>
		</div>
	)
}
